import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';
import { useStyles } from './styles';
import LazyLoad from 'react-lazyload';
import Image from 'next/image';

const Props = {
  titlePublished: PropTypes.string,
  showTitle: PropTypes.bool,
};

const DefaultProps = {
  titlePublished: 'Published by:',
  showTitle: true,
};

export default function PublishedSectionMobile({ titlePublished, showTitle }) {
  const classes = useStyles();

  return (
    <LazyLoad offset={100}>
      <Box py={4} className={classes.publishedBySection}>
        {showTitle && (
          <Typography className={classes.title}>
            <b>{titlePublished}</b>
          </Typography>
        )}

        <Box display="flex" justifyContent="center" alignItems="center" mb={1}>
          <Box mr={4}>
            <Image
              src="/images/logos-academics-institutions/europe-mc-logo-mobile.webp"
              loading="lazy"
              alt="Europe PMC logo"
              width={133}
              height={31}
            />
          </Box>

          <Image
            src="/images/logos-academics-institutions/frontiers-logo-mobile.webp"
            loading="lazy"
            alt="Frontiers logo"
            width={110}
            height={31}
          />
        </Box>

        <Box display="flex" justifyContent="center" alignItems="center" mb={1}>
          <Image
            src="/images/logos-academics-institutions/cell-press-logo-mobile.webp"
            loading="lazy"
            alt="Cellpress logo"
            width={117}
            height={31}
          />

          {/* <Box px={3}>
            <Image
              src="/images/logos-academics-institutions/elsevier-log-mobile.webp"
              loading="lazy"
              alt="Elsevier logo"
              width={102}
              height={51}
            />
          </Box> */}

          <Image
            src="/images/logos-academics-institutions/nih-logo-mobile.webp"
            loading="lazy"
            alt="NIH logo"
            width={68}
            height={68}
          />
        </Box>

        <Box display="flex" justifyContent="center" alignItems="center">
          <Box mr={4}>
            <Image
              src="/images/logos-academics-institutions/springer-nature-logo-mobile.webp"
              loading="lazy"
              alt="Springer nature logo"
              width={91}
              height={45}
            />
          </Box>

          <Image
            src="/images/logos-academics-institutions/science-aaas-logo-mobile.webp"
            loading="lazy"
            alt="Science AAAS logo"
            width={95}
            height={42}
          />
        </Box>
      </Box>
    </LazyLoad>
  );
}

PublishedSectionMobile.propTypes = Props;
PublishedSectionMobile.defaultProps = DefaultProps;
